import { Component, OnInit } from '@angular/core';
import { UserLogin } from 'src/app/models/userlogin';
import { LoginService } from 'src/app/services/login.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent implements OnInit {

  constructor(private loginService: LoginService, private notification: NotificationService) {
    this.loginService.User.subscribe(x => this.User = x);
    this.notification.Loading.subscribe(x => this.Loading = x);
  }
  ngOnInit(): void {
  }

  Loading = false;
  Production = environment.production;
  User: UserLogin | null = null;

  logout() {
    this.loginService.logout();
  }
  isAdmin() {
    if(this.User?.Role == 'Admin')
      return true;
    return false;
  }
}
